// The quick "create something" actions, as data. The header's + menu
// (QuickAdd) and the global search dialog both render from this list, so a
// new action shows up in both.
//
// check(ctx) mirrors QuickAdd's historic gating exactly - note it uses raw
// team membership (no site-admin bypass), unlike page visibility.

export const QUICK_ACTIONS = [
  {
    id: 'action.task',
    label: 'Task',
    path: '/tasks/new',
    icon: 'assignmentLate',
    iconColor: 'anGrey',
    keywords: 'new task todo create',
    check: (ctx) => !!ctx.user?.employee?.canReceiveTasks,
  },
  {
    id: 'action.event',
    label: 'Event',
    path: '/events/add-new',
    icon: 'event',
    iconColor: 'anRed',
    keywords: 'new event create add',
    check: (ctx) => ctx.teams.includes('Event Planning'),
  },
  {
    id: 'action.ptsBooking',
    label: 'PTS Booking',
    path: '/pts/bookings/new-booking',
    icon: 'schedule',
    iconColor: 'contrast',
    keywords: 'new pts booking patient transport create',
    check: (ctx) => ctx.ptsAccess.includes('CoOrdinator'),
  },
  {
    id: 'action.epcr',
    label: 'ePCR',
    path: '/epcr',
    icon: 'folderShared',
    iconColor: 'anOrange',
    keywords: 'new epcr pcr patient record start',
  },
  {
    id: 'action.incident',
    label: 'Incident',
    path: '/report-incident',
    icon: 'incident',
    iconColor: 'anBlue',
    keywords: 'report incident new safety',
  },
  {
    id: 'action.speakUp',
    label: 'Speak Up',
    path: '/speak-up',
    icon: 'speakUp',
    iconColor: 'anPurple',
    keywords: 'speak up concern raise anonymous',
    check: (ctx) => ctx.orgSettings?.speakUpSettings?.enabled !== false,
  },
  {
    id: 'action.defect',
    label: 'Defect',
    path: '/report-defect',
    icon: 'build',
    iconColor: 'anOrange',
    keywords: 'report defect fault new broken',
  },
  {
    id: 'action.startOfShift',
    label: 'Start of Shift Check',
    path: '/start-of-shift',
    icon: 'noCrash',
    iconColor: 'anGrey',
    keywords: 'start shift check vdi new',
  },
  {
    id: 'action.vehicleClean',
    label: 'Vehicle Clean',
    path: '/vehicle-clean',
    icon: 'carWash',
    iconColor: 'anRed',
    keywords: 'vehicle clean record new',
  },
  {
    id: 'action.fuel',
    label: 'Fuel',
    path: '/record-fuel',
    icon: 'fuel',
    iconColor: 'anOrange',
    keywords: 'record fuel refuel new',
  },
  {
    id: 'action.announcement',
    label: 'Announcement',
    path: '/announcements/add-new',
    icon: 'announcement',
    iconColor: 'anGreen',
    keywords: 'new announcement create notice',
    check: (ctx) => ctx.teams.includes('Governance'),
  },
]

export const getVisibleActions = (ctx) =>
  QUICK_ACTIONS.filter((action) => (action.check ? action.check(ctx) : true))
